// extracted by mini-css-extract-plugin
export default {"content_grid":"Footer_content_grid__pVjmp","address":"Footer_address__irMOb","signup":"Footer_signup__fRXTM","socials":"Footer_socials__oQky1"};